import TaTransactionResendPolicyModal from './TaTransactionResendPolicyModal'

export default TaTransactionResendPolicyModal
